import {useQuery} from '@tanstack/react-query'

import {Api} from '../api'

// The API returns an array where indices are IDs and values are enum names
export type HeatZoneSettingDto = string

const HEAT_ZONES_API_PATH = 'plants/refractory-planner/kilns/settings/heat-zones'

export const useGetHeatZoneNames = () => {
  return useQuery({
    queryKey: ['heat-zones'],
    queryFn: async () => {
      const response = await Api.axiosInstance.get<HeatZoneSettingDto[]>(HEAT_ZONES_API_PATH)

      // Transform array to proper format: index as id, enumValue as the API value
      return response.data.map((enumValue, index) => ({
        id: String(index),
        enumValue: enumValue
      }))
    }
  })
}
